import { useState, useEffect } from "react";

import colors from "assets/theme/base/colors";
import VuiInput from "components/VuiInput";
import VuiSelect from "components/VuiSelect";
import { IoIosSearch } from "react-icons/io";
import { IoMdClose } from "react-icons/io";

import { Container } from "./styles";

function SearchItem({ onClick = () => {}, onChange = () => {}, onReset = () => {} }) {
  const [txtSearch, SetTxtSearch] = useState("");
  const [txtFilter, SetTxtFilter] = useState({ label: "Nome", value: "name" });

  return (
    <Container>
      <div style={{ width: 260, marginLeft: 10 }}>
        <VuiSelect
          disabled
          name="selectFilters"
          placeholder="Selecione um filtro"
          value={txtFilter}
          options={[
            { label: "Nome", value: "name" },
            { label: "Email", value: "email" },
            { label: "Departamento", value: "departmentAcronym" },
          ]}
          onCustomChange={async (e) => {
            SetTxtFilter(e);
          }}
        />
      </div>

      <div style={{ width: 260, marginLeft: 10 }}>
        <VuiInput
          value={txtSearch}
          name="email"
          placeholder="Digite o nome"
          onChange={(e) => {
            const value = e.target.value;
            if (value.length > 0) {
              SetTxtSearch(value);
              // onChange(value);
            } else {
              SetTxtSearch("");
              onReset();
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.keyCode === 13) onClick(txtSearch, txtFilter.value);
          }}
        />
      </div>

      {txtSearch.length === 0 ? (
        <IoIosSearch
          style={{ marginLeft: 10, marginRight: 10, cursor: "pointer" }}
          onClick={() => onClick(txtSearch, txtFilter.value)}
        />
      ) : (
        <IoMdClose
          style={{ marginLeft: 10, marginRight: 10, cursor: "pointer" }}
          onClick={() => {
            SetTxtSearch("");
            onReset();
          }}
        />
      )}
    </Container>
  );
}

export default SearchItem;
